'use strict';exports.__esModule = true;var _facebook = require('./facebook.svg');var _facebook2 = _interopRequireDefault(_facebook);
var _instagram = require('./instagram.svg');var _instagram2 = _interopRequireDefault(_instagram);
var _linkedin = require('./linkedin.svg');var _linkedin2 = _interopRequireDefault(_linkedin);
var _twitter = require('./twitter.svg');var _twitter2 = _interopRequireDefault(_twitter);
var _youtube = require('./youtube.svg');var _youtube2 = _interopRequireDefault(_youtube);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  facebook: _facebook2.default,
  instagram: _instagram2.default,
  linkedin: _linkedin2.default,
  twitter: _twitter2.default,
  youtube: _youtube2.default };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./static/icons/social/index.js
// module id = 3168
// module chunks = 0